<template>
  <main id="content" class="dlnkmediatheque_book" role="main">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <div class="position-relative bg-primary overflow-hidden">
      <div class="container position-relative z-index-2 space-top-1 space-top-md-1 space-bottom-1 space-bottom-md-1">
        <div class="w-md-80 w-xl-60 text-center mx-md-auto">
          <h1 class="text-white mb-4">{{ book.title }}</h1>
        </div>
      </div>
      <figure class="position-absolute right-0 bottom-0 left-0 mb-n1">
        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
          <path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
        </svg>
      </figure>
    </div>

    <div class="container space-top-1 space-top-sm-2">
      <div class="row">
        <!-- Picture Section -->
        <div class="col-lg-6 mb-7 mb-lg-0">
          <div class="pr-lg-4">
            <div class="position-relative">
              <!-- Main Slider -->
              <img class="img-fluid w-100 rounded-lg"
                   :src="'/modules/dlnkmediatheque/actions/get_file.php?uuid=' + book.uuid" alt="Book image">
            </div>
            <div class="position-absolute top-0 left-1 pt-3 pl-3">
              <span v-if="parseInt(book.loaned)" class="badge badge-danger badge-pill">En prêt</span>
              <span v-else-if="parseInt(book.reserved)" class="badge badge-warning badge-pill">Réservé</span>
              <span v-else class="badge badge-success badge-pill">Disponible</span>
            </div>
          </div>

        </div>
        <!-- Picture Section -->

        <div class="col-lg-6">

          <div v-if="admin" class="position-absolute top-0 right-0 pt-3 pr-3">
            <a :href="'/module/dlnkmediatheque/edit_book?book_id=' + book.id"
               class="btn btn-xs btn-icon btn-outline-info rounded-circle"
               data-toggle="tooltip" data-placement="top" title="Modifier le livre">
              <i class="fas fa-edit"></i>
            </a>
          </div>

          <!-- Title -->
          <div class="mb-5">
            <h1 class="h2">{{ book.title }}</h1>
            <p v-html="book.synopsis"></p>
          </div>

          <hr class="my-5">

          <!-- Book Characteristic -->
          <ul class="list-unstyled mb-0">
            <li class="media mb-1">
              <div class="d-flex w-40 w-sm-30">
                <h2 class="h5">Editeur</h2>
              </div>
              <div class="media-body">
                <span class="text-muted">
                  {{ book.editor }}
                </span>
              </div>
            </li>

<!--            <li class="media mb-1">-->
<!--              <div class="d-flex w-40 w-sm-30">-->
<!--                <h2 class="h5">Categorie</h2>-->
<!--              </div>-->
<!--              <div class="media-body">-->
<!--                <small class="text-muted">-->
<!--                  {{ book.category }}-->
<!--                </small>-->
<!--              </div>-->
<!--            </li>-->

            <li class="media mb-1">
              <div class="d-flex w-40 w-sm-30">
                <h3 class="h5">Genre</h3>
              </div>
              <div class="media-body">
                <span class="text-muted">
                  {{ book.genre }}
                </span>
              </div>
            </li>

            <li class="media mb-1">
              <div class="d-flex w-40 w-sm-30">
                <h3 class="h5">Tranche d'age</h3>
              </div>
              <div class="media-body">
                <span class="text-muted">
                  {{ book.age_range }} ans
                </span>
              </div>
            </li>

            <li class="media mb-1">
              <div class="d-flex w-40 w-sm-30">
                <h4 class="h5">Lieu</h4>
              </div>
              <div class="media-body">
                <span class="text-muted">
                  {{ book.place }}
                </span>
              </div>
            </li>

            <li v-if="admin" class="media">
              <div class="d-flex w-40 w-sm-30">
                <h5>Emprunteur</h5>
              </div>
              <div class="media-body">
                <span class="d-block text-muted mb-1">
                  {{ loan.name }}
                </span>
              </div>
            </li>

            <li v-if="admin" class="media">
              <div class="d-flex w-40 w-sm-30">
                <h5>Date emprunt</h5>
              </div>
              <div class="media-body">
                <span class="d-block text-muted mb-1">
                  {{ loan.loan_date }}
                </span>
              </div>
            </li>

            <li v-if="admin" class="media mb-1">
              <div class="d-flex w-40 w-sm-30">
                <h3 class="h5">ISBN</h3>
              </div>
              <div class="media-body">
                <span class="text-muted">
                  {{ book.isbn }}
                </span>
              </div>
            </li>

          </ul>
          <!-- Book Characteristic -->

          <hr class="my-5">

        </div>
        <!-- End Book Description -->

      </div>

      <div v-if="admin">
        <div v-if="parseInt(book.loaned) == 0" class="mt-4">

          <form method="post" id="loan_form" action="" @submit.prevent="submit_loan()" class="needs-validation row"
                novalidate>

            <div class="col-12">
              <h1 class="h2">Emprunt</h1>

              <hr class="my-5">

            </div>

            <div class="col-lg-6">

              <div class="card card-bordered shadow-none">

                <div class="card-body">

                  <h2 class="h4 p-2">Réservation en attente</h2>

                  <table v-if="reservations.length > 0" class="table mt-2">
                    <thead>
                    <tr>
                      <th scope="col"></th>
                      <th scope="col">Nom</th>
                      <th scope="col">Date demande</th>
                      <th scope="col">Action</th>
                    </tr>
                    </thead>
                    <tbody>

                    <tr v-for="reservation in reservations" :key="reservation.id">
                      <th scope="row">
                        <input class="form-check-input" type="radio" name="borrower_id" :value="reservation.id_customer"
                               required>
                      </th>
                      <td>{{ reservation.firstname }} {{ reservation.lastname }}</td>
                      <td>{{ reservation.created_at }}</td>
                      <td>
                        <a href="javascript:void(0);" data-toggle="tooltip" data-placement="top" title="Modifier le livre"
                           class="btn btn-xs btn-icon btn-outline-danger rounded-circle"
                           @click="delete_reservation(reservation.id)">
                          <i class="fas fa-trash"></i></a>
                      </td>
                    </tr>

                    </tbody>
                  </table>
                  <div v-else class="alert alert-info">Pas de réservation</div>


                  <h2 class="h4 p-2">ou rechercher un membre</h2>

                  <!-- Member search bar-->
                  <div class="input-group input-group-merge">
                    <input type="search" class="form-control form-control-sm mb-2" placeholder="Chercher un membre"
                           aria-label="Chercher un membre" v-model="member_query">
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="fas fa-search"></i>
                      </span>
                    </div>
                    <div>
                      <br>
                      <small v-if="search_member_message.length > 5"
                             class="form-text text-muted d-block">{{ search_member_message }}</small>
                    </div>
                  </div>
                  <!-- END member search bar-->

                  <div v-for="member in members" :key="member.id_customer" class="form-check font-size-1 text-lh-lg">
                    <input type="radio" name="borrower_id" class="form-check-input"
                           :value="member.id_customer" :id="'borrower_' + member.id_customer" required>
                    <label class="form-check-label" for="'borrower_' + member.id_customer">{{ member.name }}</label>
                  </div>
                </div>

              </div>

            </div>
            <div class="col-lg-6">


              <div class="row form-group">
                <label for="loan_condition-1" class="col-sm-3 col-form-label input-label">État</label>

                <div class="col-sm-9">
                  <!-- Book Condition -->
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="loan_condition" id="loan_condition-1" value="0"
                           required>
                    <label class="form-check-label font-size-1 text-lh-lg" for="loan_condition-1">
                      Neuf
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="loan_condition" id="loan_condition-2" value="1"
                           required>
                    <label class="form-check-label font-size-1 text-lh-lg" for="loan_condition-2">
                      Très bon état
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="loan_condition" id="loan_condition-3" value="2"
                           checked>
                    <label class="form-check-label font-size-1 text-lh-lg" for="loan_condition-3">
                      Bon état
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="loan_condition" id="loan_condition-4" value="3"
                           required>
                    <label class="form-check-label font-size-1 text-lh-lg" for="loan_condition-4">
                      Satisfaisant
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="loan_condition" id="loan_condition-5" value="4"
                           required>
                    <label class="form-check-label font-size-1 text-lh-lg" for="loan_condition-5">
                      A changer
                    </label>
                  </div>

                </div>

                <div class="col-sm-12 mt-2">
                <textarea class="form-control form-control-sm" name="loan_comment" placeholder="Remarque sur le livre"
                          maxlength="400" rows="8"></textarea>
                </div>


              </div>


              <span>
               (En signant , tu t'engages à rendre le livre à temps et en bon état.)
            </span>


              <VueSignaturePad
                  id="loan_signature"
                  width="100%"
                  height="280px"
                  ref="signaturePad"
                  :options="signature_options"
              />

              <div class="row border-top">
                <div class="col-6 offset-lg-6 col-lg-3 mt-2">
                  <button type="button" class="btn btn-block btn-primary btn-pill transition-3d-hover" @click.prevent="undo">
                    <i class="fas fa-undo"></i>&nbsp; Effacer
                  </button>
                </div>
                <div class="col-6 col-lg-3 mt-2">
                  <button type="submit" class="btn btn-block btn-primary btn-pill transition-3d-hover">
                    <i class="fas fa-save"></i>&nbsp; Valider
                  </button>
                </div>
              </div>

            </div>

          </form>

        </div>
        <div v-else class="mt-4">

          <form method="post" id="return_form" action="" @submit.prevent="submit_return()" class="needs-validation row"
                novalidate>

            <div class="col-12">
              <h1 class="h2">Retour</h1>

              <hr class="my-5">

            </div>

            <div class="col-lg-6">

              <div class="card card-bordered shadow-none">

                <div class="card-body">

                  <div class="row form-group">
                    <label for="return_condition-1" class="col-sm-3 col-form-label input-label">État</label>

                    <div class="col-sm-9">
                      <!-- Book Condition -->
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="return_condition" id="return_condition-1"
                               value="0" required>
                        <label class="form-check-label font-size-1 text-lh-lg" for="return_condition-1">
                          Neuf
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="return_condition" id="return_condition-2"
                               value="1" required>
                        <label class="form-check-label font-size-1 text-lh-lg" for="return_condition-2">
                          Très bon état
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="return_condition" id="return_condition-3"
                               value="2" checked>
                        <label class="form-check-label font-size-1 text-lh-lg" for="return_condition-3">
                          Bon état
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="return_condition" id="return_condition-4"
                               value="3" required>
                        <label class="form-check-label font-size-1 text-lh-lg" for="return_condition-4">
                          Satisfaisant
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="radio" name="return_condition" id="return_condition-5"
                               value="4" required>
                        <label class="form-check-label font-size-1 text-lh-lg" for="return_condition-5">
                          A changer
                        </label>
                      </div>

                    </div>

                    <div class="col-sm-12 mt-2">
                <textarea class="form-control form-control-sm" name="return_comment" placeholder="Remarque sur le livre"
                          maxlength="400" rows="10"></textarea>
                    </div>

                  </div>

                </div>

              </div>

            </div>
            <div class="col-lg-6">

              <div class="card card-bordered shadow-none">

                <div class="card-body">

                  <h2 class="h4">Signature :</h2>

                  <VueSignaturePad
                      id="return_signature"
                      width="100%"
                      height="280px"
                      ref="signaturePad"
                      :options="signature_options"
                  />

                  <div class="row border-top">
                    <div class="col-6 offset-lg-6 col-lg-3 mt-2">
                      <button type="button" class="btn btn-block btn-primary btn-pill transition-3d-hover" @click.prevent="undo">
                        <i class="fas fa-undo"></i>&nbsp; Effacer
                      </button>
                    </div>
                    <div class="col-6 col-lg-3 mt-2">
                      <button type="submit" class="btn btn-block btn-primary btn-pill transition-3d-hover">
                        <i class="fas fa-save"></i>&nbsp; Valider
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </form>

        </div>
      </div>


      <a href="/module/dlnkmediatheque/books" title="admin e-bibliotheque" class="btn btn-primary mb-4 mt-6">
        <i class="fas fa-chevron-left"></i>&nbsp;Retour à la bibliothèque
      </a>

    </div>


  </main>


</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {

  props: {
    book_id: Number
  },

  data: function () {
    return {
      admin: Boolean,
      book: Array(),
      loan: Object,
      reservations: Array(),
      member_query: "",
      search_member_message: String,
      members: Array(),
      message: "",
      message_type: "",
      signature_options: {
        penColor: "#1e2022"
      }
    }
  },

  mounted() {
    this.get_data()
  },

  watch: {
    member_query: function (new_val, old_val) {
      if (new_val.length > 2) {
        this.search_member_message = ""
        this.get_members();
      } else if (new_val.length > 0) {
        this.search_member_message = "Veuillez taper au moins 3 caractères pour démarrer la recherche"
      }
    }
  },

  methods: {

    close_message: function () {
      this.message = "";
      this.message_type = "";
    },

    delete_reservation: function (reservation_id) {
      let _this = this;

      let url = '/modules/dlnkmediatheque/actions/reservations.php?reservation_id=' + reservation_id;

      axios.delete(url)
          .then(function (response) {
            _this.get_data()
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    },

    get_members: function () {
      let _this = this;

      let url = '/modules/dlnkmediatheque/actions/members.php?query=' + _this.member_query;

      axios.get(url)
          .then(function (response) {
            _this.members = response.data.members
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    },

    get_data: function () {
      let _this = this;

      let url = '/modules/dlnkmediatheque/actions/book.php?book_id=' + _this.book_id;

      axios.get(url)
          .then(function (response) {
            _this.book = response.data.book
            _this.admin = response.data.admin
            _this.reservations = response.data.reservations
            _this.loan = response.data.loan
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    },

    submit_loan() {
      const _this = this;
      const url = '/modules/dlnkmediatheque/actions/loan.php';

      const form_element = document.getElementById("loan_form");
      const form_data = new FormData(form_element);
      form_data.append('book_id', _this.book_id)

      axios({
        method: 'post',
        url: url,
        data: form_data
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if (status) {
              _this.message = "Emprunt enregistré."
              _this.message_type = "alert-success"
              _this.get_data()
            } else {
              _this.message = response.data.error;
              _this.message_type = 'alert-danger'
            }
          })
          .catch(function (response) {
            //handle error
          });

    },

    submit_return() {
      const _this = this;
      const url = '/modules/dlnkmediatheque/actions/return.php';

      const form_element = document.getElementById("return_form");
      const form_data = new FormData(form_element);
      form_data.append('book_id', _this.book_id)

      axios({
        method: 'post',
        url: url,
        data: form_data
      })
          .then(function (response) {
            //handle success
            const status = response.data.status;

            if (status) {
              _this.message = "Retour enregistré."
              _this.message_type = "alert-success"
              _this.get_data()
            } else {
              _this.message = response.data.error;
              _this.message_type = 'alert-danger'
            }
          })
          .catch(function (response) {
            //handle error
          });

    },

    // Signature management
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      const {isEmpty, data} = this.$refs.signaturePad.saveSignature();

      alert("Open DevTools see the save data.");
      console.log(isEmpty);
      console.log(data);
    },
    // End Signature management

  }
}

</script>

<style scoped>

p {
  font-family: "Open Sans", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
  text-align: left;
}

#loan_signature, #return_signature {
  border: double 3px transparent;
  margin-bottom: 2rem;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
  radial-gradient(circle at top left, #4bc5e8, #9f6274);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

</style>

